export const STATUT_PREVALIDE = "PRÉVALIDÉ ÉLECTRONIQUEMENT — SIGNATURE PHYSIQUE À RÉCUPÉRER";
export const STATUT_DEFINITIF = "VALIDÉ DÉFINITIVEMENT — SIGNATURE PHYSIQUE REÇUE";
export const statutsTransmission = { PREPARE: "PRÉPARÉ — ENVOI À CONFIRMER", PREVALIDE: STATUT_PREVALIDE, DEFINITIF: STATUT_DEFINITIF, REFUSE: "REFUSÉ" };
export const telephoneTransmission = v => String(v || "").replace(/\D/g, "").replace(/^00/, "").replace(/^0/, "33");
const emailTransmission = v => String(v || "").trim().toLowerCase();
export function dedupliquerDestinataires(items = []) {
  return items.reduce((uniques, item) => {
    const email = emailTransmission(item?.email);
    const telephone = telephoneTransmission(item?.telephone);
    const index = uniques.findIndex((existant) =>
      (email && emailTransmission(existant.email) === email)
      || (telephone && telephoneTransmission(existant.telephone) === telephone)
      || (item?.contact_id && existant.contact_id === item.contact_id));
    const propre = { ...item, email: String(item?.email || "").trim(), telephone: String(item?.telephone || "").trim() };
    if (index < 0) uniques.push(propre);
    else uniques[index] = {
      ...uniques[index], ...propre,
      email_selectionne: uniques[index].email_selectionne === true || propre.email_selectionne === true,
      whatsapp_selectionne: uniques[index].whatsapp_selectionne === true || propre.whatsapp_selectionne === true
    };
    return uniques;
  }, []);
}
export function preparerMessageTransmission(data) {
  const recipients = dedupliquerDestinataires(data.recipients || []);
  const signature = [data.commercial?.nom, data.commercial?.fonction, data.commercial?.telephone, data.commercial?.email].filter(Boolean).join("\n");
  const code = data.otp !== false
    ? "Un code de confirmation vous sera demandé pour prévalider cette version. Contactez votre commercial pour les modalités de remise du code ; aucun code n’est envoyé automatiquement par CRM actuellement."
    : "La prévalidation s’effectue par acceptation explicite, sans code de confirmation pour ce groupe.";
  const texte = `Bonjour ${recipients[0]?.nom || ""},\n\nVotre devis ${data.numero} — Version V${data.version} pour ${data.club} est disponible.\n\n1 — PRÉVALIDATION ÉLECTRONIQUE\n${code}\nConsultez puis prévalidez cette version :\n${data.lien}\n\n2 — SIGNATURE PHYSIQUE OBLIGATOIRE\nAprès la prévalidation, le devis doit également être signé physiquement. Il ne sera validé définitivement dans CRM qu’après réception du document signé et confirmation par votre commercial.\n\nCordialement,\n${signature}`;
  const objet = `Validation de votre devis ${data.numero} — ${data.club} — V${data.version}`;
  const emails = recipients.map(c => c.email).filter(Boolean);
  const copy = emails.some(email => emailTransmission(email) === emailTransmission(data.copy)) ? "" : String(data.copy || "").trim();
  return { texte, objet, recipients, copy, mailto: `mailto:${encodeURIComponent(emails.join(","))}?cc=${encodeURIComponent(copy)}&subject=${encodeURIComponent(objet)}&body=${encodeURIComponent(texte)}` };
}
export async function appelerTransmission(client, body) {
  const { data, error } = await client.functions.invoke("devis-documents", { body });
  if (error || !data?.ok) {
    const code = data?.code;
    throw new Error(code === "OTP_INVALIDE" ? "Code incorrect, expiré ou déjà utilisé. Contactez votre commercial."
      : code === "ACCES_REFUSE" ? "Accès refusé."
      : code === "ATTENDRE" ? "Veuillez patienter avant de demander un autre code."
      : "Opération indisponible. Vérifiez la configuration du nouveau parcours (migration et fonction serveur), puis réessayez. Aucun envoi automatique n’a été effectué.");
  }
  return data;
}
